import { render } from "./CadastroTipoOperadoraView.vue?vue&type=template&id=24b7e866"
import script from "./CadastroTipoOperadoraView.vue?vue&type=script&lang=js"
export * from "./CadastroTipoOperadoraView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__